import React, { Component } from 'react';
import './App.scss';
import { Switch, Route, withRouter } from 'react-router-dom';
import { TouchpointListComponent, CreateTouchpointResponseComponent, ViewTouchpointResponseComponent, EditTouchpointResponseComponent } from './touchpoints';
import { features, featureHelpers, HiddenFeature } from './features';
import { RequestAppointmentContainerComponent } from './dashboard';
import { integrationTypes } from './tenantInfo';
import AppContent from "./app-content";

/** All the pages in the Application that should not display the privacy links */
class AppNoLinks extends Component {

  render() {
    const routes = (
      <Switch>
        <Route
          exact path="/sites/:siteId/programs/:programId/forms/:touchpointFormId/create"
          component={featureHelpers.meetsFeatureRequirements([features.apricotPortalTier2], [integrationTypes.apricot]) ? CreateTouchpointResponseComponent : HiddenFeature} />
        <Route
          exact path="/sites/:siteId/programs/:programId/forms/:touchpointFormId/responses/:responseId/view"
          component={featureHelpers.meetsFeatureRequirements([features.apricotPortalTier2], [integrationTypes.apricot]) ? ViewTouchpointResponseComponent : HiddenFeature} />
        <Route
          exact path="/sites/:siteId/programs/:programId/forms/:touchpointFormId/responses/:responseId/edit"
          component={featureHelpers.meetsFeatureRequirements([features.apricotPortalTier2], [integrationTypes.apricot]) ? EditTouchpointResponseComponent : HiddenFeature} />
        <Route
          exact path="/sites/:siteId/programs/:programId/forms/:touchpointFormId"
          component={featureHelpers.meetsFeatureRequirements([features.apricotPortalTier2], [integrationTypes.apricot]) ? TouchpointListComponent : HiddenFeature} />
        <Route 
          exact path="/requestappointments"
          component={featureHelpers.meetsFeatureRequirements([features.connectScheduler], [integrationTypes.apricot]) ? RequestAppointmentContainerComponent : HiddenFeature} />
      </Switch>
    );
    return (
      <AppContent hidePrivacyLinks={true} routes={routes}/>
    );
  }
}

export default withRouter(AppNoLinks);



// WEBPACK FOOTER //
// src/AppNoLinks.js